import { Feature, GeoJsonProperties, Geometry } from 'geojson';
import { useEffect, useState } from 'react';

import { Logger } from '@/lib/logs/logger';
import { getProxiedMapServerUrl } from '@/utils/mapServer';

export const useSiemensData = () => {
  const [data, setData] = useState<Feature<Geometry, GeoJsonProperties> | null>(null);

  useEffect(() => {
    const rawUrl =
      'https://mapserver.landler.io/geoserver/landler/wfs?service=WFS&version=1.1.0&request=GetFeature&typeName=landler:protected_areas_30e363d3e8c59f2c1319f8d73d48e3ad26db5e087951a4d7ab809c6f5401aea8&outputFormat=application/json';

    const mapServerUrl = getProxiedMapServerUrl(rawUrl);

    fetch(mapServerUrl, { credentials: 'include' as const })
      .then((res) => res.json())
      .then((jsonData) => setData(jsonData))
      .catch((error) => Logger.error(`Error fetching GeoJSON: ${error}`));
  }, []);

  return data;
};
